<div class="modal-header">
	<h4 class="modal-title">Revised invoice options</h4>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body">
	<div>
		<p>
			Select one of the below options
		</p>
		<mat-radio-group [(ngModel)]="action">
			<p>
				<mat-radio-button value="standard">Standard</mat-radio-button>
			</p>
			<p>
				<mat-radio-button value="secondCustomer">Second Customer</mat-radio-button>
			</p>
		</mat-radio-group>
	</div>
</div>
<div class="modal-footer">
	<button mat-raised-button color="accent" type="button" class="btn btn-outline-dark" (click)="submit()">
		Open PDF
	</button>
	<button mat-raised-button type="button" color="btnwhite" style="margin-left: 10px!important;" (click)="close()">
		Cancel
	</button>
</div>
